<template>
<div class="wrapper"> 
  <div class="motai" @touchmove.stop.prevent>
    <div class="preivew">
      <div class="preivew-left">
        <div class="header-icon">
          <van-icon name="arrow-left" @click="back"/>
        </div>
        <div class="sw">
          <van-swipe indicator-color="white"  :autoplay="3000" :touchable="false" style=" width: 100%; height: 100%;">
            <van-swipe-item v-for="(item, index) in list" :key="index">
              <img :src="item | thumbnailGem(600, 600)" alt>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="preivew-right">
        <div id="editor"></div>
      </div>
    </div>
  </div>
</div>
  
</template>

<script>
import Editor from "wangeditor";
import "wangeditor/release/wangEditor.min.css";
import { Swipe, SwipeItem, Icon } from "vant";
import {modelDtails} from '@/api/modelReq';
import {Share} from '@/api/wechat';


export default {
  name: "preivew",

  data() {
    return {
      value1: 0,
      editor: "",
      arrow: "always",
      list: [],
    };
  },

  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon
  },

  methods: {
    back() {
      this.$router.go(-1);
    }
  },

  mounted() {
    this.editor = new Editor("#editor");
    this.editor.create();
    this.editor.$textElem.attr("contenteditable", false);
    modelDtails(this.$route.params.id).then(res=>{
      this.list = res.preview360;
      this.editor.txt.html(res.content);
      if(this.$isWeChat) {  
        Share(res.name, res.thumbnail, res.content, window.location.href)  
      }
    }) 
  }
};
</script>

<style lang="less" scoped>
/deep/.demo-carousel {
  img {
    width: 100%;
    height: 100%;
  }
}
@media screen and (orientation: portrait) {
  .wrapper {
    position: absolute;
    width: 100vh;
    height: 100vw;
    top: 0;
    left: 100vw;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
    transform-origin: 0% 0%;
  }
}

@media screen and (orientation: landscape) {
  .wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
}

.motai {
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(55, 55, 55, 0.6);
  z-index: 99999;
  .preivew {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    background: #f7f7f7;
    .preivew-left {
      width: 50%;
      height: 100%;
      background: rgba(255, 255, 255, 1);
      padding-top: 3%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      padding-left: 2%;
      padding-right: 2%;
      .sw {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .header-icon {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 5%;
        box-sizing: border-box;
        i {
          font-size: 3vw;
          color: #030303;
        }
      }
    }
    .preivew-right {
      width: 50%;
      height: 100%;
      background: rgba(247, 247, 247, 1);
      // border-radius:4px;
      padding-left: 3%;
      padding-top: 6%;
      box-sizing: border-box;
      #editor {
        width: 100%;
        height: 100%;

        .w-e-text-container {
          height: 100%;
        }
        /deep/.w-e-toolbar {
          display: none !important;
        }
        /deep/.w-e-text-container {
          height: 100% !important;
          border: none !important;
        }
        /deep/.w-e-text {
          font-size: 16px;
          font-weight: 500;
          color: rgba(28, 28, 28, 1);
          /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
          &::-webkit-scrollbar {
            width: 6px; /*滚动条宽度*/
            height: 16px; /*滚动条高度*/
          }

          /*定义滚动条轨道 内阴影+圆角*/
          &::-webkit-scrollbar-track {
            // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            border-radius: 6px; /*滚动条的背景区域的圆角*/
            background-color: transparent; /*滚动条的背景颜色*/
          }

          /*定义滑块 内阴影+圆角*/
          &::-webkit-scrollbar-thumb {
            border-radius: 6px; /*滚动条的圆角*/
            // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: #c8cbce; /*滚动条的背景颜色*/
          }
        }
      }
    }
  }

  // .preivew.transverse {
  //   position: absolute;
  //   width: 100vh;
  //   height: 100vw;
  //   top: 0;
  //   left: 100vw;
  //   transform: rotate(90deg);
  //   transform-origin: 0% 0%;
  //   .preivew-left {
  //     .header-icon {
  //       i {
  //         font-size: 7vw;
  //       }
  //     }
  //     .sw {
  //       width: 100%;
  //       height: 100%;
  //       .van-swipe {
  //         width: 100%;
  //         height: 100%;
  //         img {
  //           width: 46vh;
  //           height: 81vw;
  //         }
  //       }
  //     }
  //   }
  // }
  // .preivew.vertical {
  //   width: 100%;
  //   height: 100%;
  //   flex-direction: column;
  //   padding: 8px;
  //   border-radius: 0;
  //   .preivew-left {
  //     width: 100%;
  //     height: auto;
  //     padding: 0;
  //     position: relative;
  //     .header-icon {
  //       position: absolute;
  //       top: 10px;
  //       left: 0;
  //       padding: 0;
  //       padding-top: 0;
  //       margin-bottom: 0;
  //       z-index: 10001;
  //       i {
  //         font-size: 6vw;
  //       }
  //     }
  //     .sw {
  //       width: 100%;
  //       /deep/.van-swipe {
  //         width: 100%;
  //         height: 100%;
  //         /deep/img {
  //           width: 100%;
  //           height: 100%;
  //           object-fit: cover;
  //         }
  //       }
  //     }
  //   }
  //   .preivew-right {
  //     width: 100%;
  //     flex: 1;
  //     height: auto;
  //     padding: 0;
  //   }
  // }
}
</style>
